import(/* webpackMode: "eager" */ "/home/app/workspace/node_modules/next/dist/client/app-dir/link.js");
